import {Item} from "../../API";
import {ItemModelSnapshotIn} from "../WorkspaceStore";


import {parseJsonOrFallback, parseOrFallback} from "./parseJsonOrFallback";


export const itemToItemMSTSnapshotIn = (itemServer: Item): ItemModelSnapshotIn => {
    const itemSnapshotIn: ItemModelSnapshotIn = {
        ...itemServer,
        name: itemServer.name ?? '',
        description: itemServer.description ?? '',
        childIds: parseJsonOrFallback(itemServer.childIds),
        parentIds: parseJsonOrFallback(itemServer.parentIds),
        pinnedIds: parseJsonOrFallback(itemServer.pinnedIds || '[]'),
        statusSourceLibraryId: itemServer.statusSourceLibraryId || null,
        statusRestoreParentIds: parseJsonOrFallback(itemServer.statusRestoreParentIds || '[]'),
        acknowledgement: parseOrFallback(itemServer.acknowledgement, {}),
        acknowledgementRequired: itemServer.acknowledgementRequired || false,
        lastSyncedVersion: itemServer.version,
        pinned: itemServer.pinned === null ? false : itemServer.pinned
    };

    return itemSnapshotIn;
}

export function adjustWorkspaceItems(awsItems?: any) {
    return awsItems?.reduce((accumulator: any, item: any) => Object.assign(accumulator, {[item.id]: item}), {}) || {};
}
